/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LanguageProficiency } from '../../models/language-proficiency';

export interface UpdateLanguageProficiency$Params {
  profileId: string;
  id: string;
      body?: LanguageProficiency
}

export function updateLanguageProficiency(http: HttpClient, rootUrl: string, params: UpdateLanguageProficiency$Params, context?: HttpContext): Observable<StrictHttpResponse<LanguageProficiency>> {
  const rb = new RequestBuilder(rootUrl, updateLanguageProficiency.PATH, 'put');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LanguageProficiency>;
    })
  );
}

updateLanguageProficiency.PATH = '/studentprofile/{profileId}/languageproficiency/{id}';
